import { WithStyles, withStyles } from '@mui/styles';
import { RouteComponentProps } from 'react-router-dom';

import { WalletView } from './walletView';
import { muiStyles } from './walletViewStyles';

type RouteParams = {
    walletId: string;
};

export interface IWalletViewProps extends RouteComponentProps<RouteParams>, WithStyles<typeof muiStyles> {
    location: any;
}

export default withStyles(muiStyles)(WalletView);